import { DateRangePicker, type DateRange, MultiInputDateRangeField } from '@mui/x-date-pickers-pro';
import type { Dayjs } from 'dayjs';

import { Field } from '../../shared/Field/Field';

type Props = {
  dateFilter?: DateRange<Dayjs>;
  setDateFilter: (value: DateRange<Dayjs>) => void;
};

function DateFilter({ dateFilter, setDateFilter }: Readonly<Props>) {
  return (
    <Field label="Event Date" tooltip="Filter event using date range" fullWidth>
      <DateRangePicker
        slotProps={{
          textField: { size: 'small' },
          actionBar: {
            actions: ['accept', 'clear'],
            sx: { button: { color: '#fff', backgroundColor: 'primary.main' } },
          },
        }}
        slots={{ field: MultiInputDateRangeField }}
        value={dateFilter}
        onChange={(newValue) => setDateFilter(newValue)}
      />
    </Field>
  );
}
export default DateFilter;
